import React from 'react';
import Skeleton from '@mui/material/Skeleton';

interface Props {
  path: string;
  alt?: string;
  className?: string;
  width?: number;
  height?: number;
}

const firebaseStorageBaseUrl = process.env.FIREBASE_STORAGE_BASE_URL;

const Image = ({ path, alt, className, width, height }: Props) => {
  const [isImgBroken, setImageState] = React.useState(false);
  const onError = React.useCallback(() => {
    setImageState(true);
  }, []);
  return (
    <>
      {!isImgBroken ? (
        <img
          className={className}
          src={`${firebaseStorageBaseUrl}${path}?alt=media`}
          loading="lazy"
          onError={onError}
          alt={alt}
          width={width}
          height={height}
        />
      ) : (
        <Skeleton
          animation={false}
          sx={{
            height,
            width,
            transform: 'scale(1, 1)',
          }}
        />
      )}
    </>
  );
};

export default Image;
